module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/praise#praise-R",
      "id": "praise-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for How the Hell Did This Happen?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/also#also-R",
      "id": "also-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by P. J. O’Rourke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/tp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/authornote#author-note-R",
      "id": "author-note-D"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/preamble#preamble-R",
      "id": "preamble-D"
    }
  }, [_vm._v("Preamble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01#ch01-R",
      "id": "ch01-D"
    }
  }, [_vm._v("1  The Campaign Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02#ch02-R",
      "id": "ch02-D"
    }
  }, [_vm._v("2  The Abominable Showman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch03#ch03-R",
      "id": "ch03-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  The Horror! The Horror!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch04#ch04-R",
      "id": "ch04-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  A Huck So Unlike Finn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch05#ch05-R",
      "id": "ch05-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  Always Look on the Bright Side of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch06#ch06-R",
      "id": "ch06-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  So Much for That")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch07#ch07-R",
      "id": "ch07-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  The Last Damn Republican Presidential Candidate Debate I’ll Ever Watch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch08#ch08-R",
      "id": "ch08-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  Say It Ain’t So, Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch09#ch09-R",
      "id": "ch09-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9  A Better Way to Choose a President, Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch10#ch10-R",
      "id": "ch10-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Walking Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch11#ch11-R",
      "id": "ch11-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Time to Pull the Plug on Ben Carson’s Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch12#ch12-R",
      "id": "ch12-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 In Memoriam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch13#ch13-R",
      "id": "ch13-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Our Higgledy-Piggledy Primary System and How It Higgles Our Pigs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/ch14#ch14-R",
      "id": "ch14-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A Halfhearted Case for Marco Rubio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch15#ch15-R",
      "id": "ch15-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Case Against Marco Rubio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch16#ch16-R",
      "id": "ch16-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Cruz Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch17#ch17-R",
      "id": "ch17-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Fashion Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch18#ch18-R",
      "id": "ch18-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 What They Stand for, and Can We Stand It? Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch19#ch19-R",
      "id": "ch19-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 What They Stand for, and Can We Stand It? Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch20#ch20-R",
      "id": "ch20-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Paying for What We Can’t Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch21#ch21-R",
      "id": "ch21-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Another Attempt at Paying for What We Can’t Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch22#ch22-R",
      "id": "ch22-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 What They Stand for, and Can We Stand It? Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch23#ch23-R",
      "id": "ch23-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Letter to Myself in 1968")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch24#ch24-R",
      "id": "ch24-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 A Better Way to Choose a President, Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch25#ch25-R",
      "id": "ch25-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 The Last Damn National Political Convention I’ll Ever Watch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch26#ch26-R",
      "id": "ch26-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 The Democratic National Political Convention")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch27#ch27-R",
      "id": "ch27-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 I Endorse Hillary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch28#ch28-R",
      "id": "ch28-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Nowhere Leadership Is Headed To")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch29#ch29-R",
      "id": "ch29-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 The Campaign Trail of Sneers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ch30#ch30-R",
      "id": "ch30-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 The Revolt Against the Elites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/epilogue#epilogue-R",
      "id": "epilogue-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/glossary#glossary-R",
      "id": "glossary-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ack#ack-R",
      "id": "ack-D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back Cover")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 81
// module chunks = 0